// src/notifications.ts
import { messaging } from "./firebase";
import { getToken } from "firebase/messaging";
import Axios from "./redux/setupAxios";

// The backend only learns this browser's FCM token at login. The token
// changes whenever the Firebase setup changes (project/VAPID/service worker),
// and until the admin logs in again the backend keeps pushing to the dead
// token - no notification, no sound, no auto refresh. Re-register it with
// the backend on every load where it differs from what we last sent.
const syncTokenWithBackend = async (token: string) => {
  if (!localStorage.getItem("token")) return; // not logged in
  if (localStorage.getItem("fcm_token_synced") === token) return;
  try {
    await Axios.post("Org/User/FcmToken/Add/", {
      token,
      platform: "1",
      app_id: localStorage.getItem("device_id"),
      service_instance: localStorage.getItem("org_instance_id"),
    });
    localStorage.setItem("fcm_token_synced", token);
  } catch (error) {
    console.error("❌ Failed to sync FCM token:", error);
  }
};

export const requestNotificationPermission = async (): Promise<string | null> => {
  try {
    const permission = await Notification.requestPermission();

    if (permission !== "granted") {
      console.warn("❌ Permission denied");
      return null;
    }

    const token = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
    });
    if (token) {
      localStorage.setItem("fcm_token", token);
      syncTokenWithBackend(token);
      return token;
    }

    return null;
  } catch (error) {
    console.error("❌ Error getting token:", error);
    return null;
  }
};

export const initNotifications = async (): Promise<void> => {
  await requestNotificationPermission();
};
